import $ from '$/jquery'
import ox from '$/ox'
import _ from '$/underscore'
import { addReadyListener } from '$/io.ox/core/events'

if (ox.serverConfig.signinTheme && ox.serverConfig.signinTheme.trim().toLowerCase() === 'com.kun') {
  // update favicon
  addReadyListener('capabilities:server', () => {
    const icons = {
      '#favicon-ico': 'favicon.ico',
      '#favicon': 'favicon.ico'
    }
    _(icons).forEach((icon, selector) => {
      $(`head ${selector}`).attr({ href: `themes/com.kun/${icon}` }).detach().appendTo('head')
    })
  })
}
